import { AfterViewInit, Component, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { GprMaterialsV1Service, GprPrintParameterDto, MpgValuePerMainElementDto, NmdCalculationResponseDto, NmdCalculationResponseWrapperDto, PrintResultDto, ProjectDto, ValuePerPhasePerEnvironmentalEffectDto } from '../core/services/GPRMV1Service.Generated';
import { AppService } from '../core/services/app.service';
import { PerPhaseNames } from '../pages/result/perphase-names';
import { ENmdProductStatus } from '../shared/enums/nmd-product-status.enum';
import { FeatureManagementService } from '../core/services/feature-management.service';
import { DataSetSettingEnum } from '../shared/enums/data-set-setting.enum';
import { CombinationSpecificParamNamesEnum } from '../shared/enums/combination-specific-param-names.enum';
import { TranslateService } from '@ngx-translate/core';
import { ValuePerPhaseModel } from '../shared/models/value-per-phase.model';
import { EnvironmentEffects } from '../pages/result/environment-effects';
import { Indicators } from '../pages/result/indicators';
import { catchError, takeUntil, tap } from 'rxjs/operators';
import { EMPTY, Observable, Subject } from 'rxjs';
import { CombinationBuildingPrintDto } from './print-page-landscape/print-combination-building-details/print-combination-building-details.component';
import { BuildingUseFunctionNamesById } from '../shared/enums/building-use-function-names.enum';
import { NormalizeKeyPipe } from '../shared/pipes/normalize-key/normalize-key.pipe';
import { DecimalSeparatorPipe } from '../shared/pipes/decimal-separator/decimal-separator.pipe';

class MainElementDto {
    readonly colorCode: string;
    readonly id: number;
    readonly name: string;
    readonly value: number;
    readonly percentage: number;

    constructor(id: number, name: string, value: number, colorCode: string, percentage: number) {
        this.colorCode = colorCode;
        this.id = id;
        this.name = name;
        this.value = value;
        this.percentage = percentage;
    }
}

@Component({
    selector: 'app-print-page',
    templateUrl: './print-page.component.html',
    styleUrls: ['./print-page.component.scss'],
    standalone: false
})
export class PrintPageComponent implements AfterViewInit, OnDestroy {
    // Constants mapping to ParameterTypeEnum values from backend
    private static readonly PARAM_BUILDING_USE_FUNCTION = 'Gebruiksfunctie';
    private static readonly PARAM_GBO = 'usableFloorArea';
    private static readonly PARAM_NUMBER_OF_UNITS = 'numberOfUnits';
    private static readonly PARAM_FUNCTION_NEW_OR_CURRENT = 'Functies';
    private static readonly PARAM_FUNCTION_AFTER = 'Functies na ingreep';
    private static readonly PARAM_COMMON_AREA_NEW_OR_CURRENT = 'Gemeenschappelijke ruimte';
    private static readonly PARAM_COMMON_AREA_AFTER = 'Gemeenschappelijke ruimte na ingreep';
    private static readonly PARAM_FACADE_SURFACE_NEW_OR_CURRENT = 'Geveloppervlakte';
    private static readonly PARAM_FACADE_SURFACE_AFTER = 'Geveloppervlakte na ingreep';
    private static readonly PARAM_COMPACTNESS_NEW_OR_CURRENT = 'Compactheid';
    private static readonly PARAM_MPG_AMBITION_NEW_OR_CURRENT = 'Mpg ambitie';
    private static readonly PARAM_MPG_LIMIT_A2_NEW_OR_CURRENT = 'Mpg Limit';
    private static readonly PARAM_MPG_LIMIT_EASED_A2_NEW_OR_CURRENT = 'Mpg Limit Eased';
    private static readonly PARAM_MPG_LIMIT_A2_PRINT_NAME = 'MPG-EIS A2';
    private static readonly PARAM_CORRECTION_FACTOR_NEW_OR_CURRENT = 'Correctiefactor';

    environmentEffects: ValuePerPhaseModel[];
    environmentEffectsAfter: ValuePerPhaseModel[];

    indicators: ValuePerPhaseModel[];
    indicatorsAfter: ValuePerPhaseModel[];
    isExistingBuildingCal: boolean;
    existingBuildingParameters: GprPrintParameterDto[] = [];
    calculationResults: NmdCalculationResponseDto;
    calculationResultsAfter: NmdCalculationResponseDto;

    nmdCalculationResponseDto_ForExtraIndicator: NmdCalculationResponseDto;

    calculationName: string;
    printData: PrintResultDto;
    math = Math;
    dataSetSetting = DataSetSettingEnum;
    selectedDataSet: number;
    mpgResultTitle: string;
    mpgResultTitlePerMainElementTitle: string
    elementResultTitle: string;
    envirnmentalCategoryTitle: string;

    projectCharacteristics: ProjectDto;
    nmdProductStatusEnum = ENmdProductStatus;
    uploadsImageBaseUrl: string = environment.uploadsBaseUrl;
    climateChangeGWP: number = 0;
    resterendLevensduurIngreep: number = 0;
    levensduurIngreep: number = 0;
    resterendLevensduurHuidig: number = 0;
    levensduurHuidig: number = 0;
    selectedsubmenu: string;

    // MPG card
    mpgColumns: string[] = ['colorCode', 'name', 'value', 'percentage'];

    // MKI card
    mkiColumns: string[] = ['name', 'mki'];

    tableColumns: string[] = ['allphases', 'unit'];
    codes = {};

    parameterGroupsCache: Map<any, any[][]> = new Map();

    currentMainElements: MainElementDto[] = [];
    afterMainElements: MainElementDto[] = [];
    colors = [
        '#FF7A00',
        '#FFB500',
        '#FF5257',
        '#DB021F',
        '#ABB4F1',
        '#333E86',
        '#F9D5D6',
        '#FF61A9',
        '#00BBB9',
        '#00B33D',
        '#96DC00',
        '#F458F8',
        '#EA16A2',
        '#FFD600'
    ]

    // Chart config options
    chartOption = {
        gradient: false,
        showLegend: false,
        showLabels: false,
        isDoughnut: true,
        tooltipDisabled: true,
        arcWidth: 0.40,
        view: [200, 200],
        legendPosition: 'left',
        legendTitle: '',
        colorScheme: {
            domain: this.colors
        }
    }
    private _destroySubscription: Subject<boolean> = new Subject();
    isPreview: boolean = false;
    combinationBuildingDetails: CombinationBuildingPrintDto | null = null;
    isShowCombinationBuildingFeature: boolean = false;
    protected _onDestroy: Subject<void> = new Subject<void>();
    private readonly normalizeKeyPipe = new NormalizeKeyPipe();
    private readonly decimalSeparatorPipe = new DecimalSeparatorPipe();
    constructor(private _router: Router, private activatedRoute: ActivatedRoute, private appService: AppService, private _gprMaterialsService: GprMaterialsV1Service,
        private _featureService: FeatureManagementService, private _translate: TranslateService,
        private _cdr: ChangeDetectorRef) {
        this.isExistingBuildingCal = this.appService.isExistingBuildingCalculation;

        // Read any query/route params that may already be present (important when opened
        // directly in a new tab). This ensures `selectedsubmenu` / `isPreview` are set
        // before route `data` arrives so the template `*ngIf` conditions evaluate
        // correctly.
        this.selectedsubmenu = this.activatedRoute?.snapshot?.queryParams?.['type'] || this.activatedRoute?.snapshot?.params?.['type'] || this.activatedRoute?.parent?.snapshot?.params?.['type'];
        this.isPreview = this.activatedRoute?.snapshot?.queryParams?.['preview'] === 'true' || this.activatedRoute?.snapshot?.queryParams?.['preview'] === true;

        if (this.activatedRoute?.data && this.activatedRoute.data.subscribe) {
            this.activatedRoute.data.pipe(takeUntil(this._destroySubscription)).subscribe((data: { printData: PrintResultDto }) => {
                this.printData = data.printData;
                this.calculationName = this.printData.calculationName;
                this.projectCharacteristics = this.printData.projectCharacteristics;
                this.selectedDataSet = this.appService.getDatasetChoiceId();
                this.createMainElementGraphList();

                if (this.projectCharacteristics === undefined) {
                    this.projectCharacteristics = new ProjectDto();
                }

                this.setCalculationResults();
                this.setHeaderTitles();
                this.mappingPerPhasePer(this.calculationResults);
                this.mappingPerPhasePer(this.calculationResultsAfter);
                // ensure view updates when data arrives (helps when opened in new tab)
                // schedule detection asynchronously to avoid running change detection
                // while Angular is still in creation mode (which triggers an assertion).
                Promise.resolve().then(() => this._cdr.detectChanges());
            });
        }
    }

    public get isCombinationBuildingSelected(): boolean {
        return this.combinationBuildingDetails !== null;
    }

    ngOnInit() {
        

        this.activatedRoute.queryParams.pipe(takeUntil(this._destroySubscription)).subscribe(params => {
            this.selectedsubmenu = params['type'];
            this.isPreview = params['preview'] === 'true' || params['preview'] === true;

            // schedule detection asynchronously to prevent "Should be run in update mode" assertion
            Promise.resolve().then(() => this._cdr.detectChanges());
        });

        this.calculationResults?.valuePerPhasePerEnvironmentalEffectCategory?.slice().reverse().forEach(item => {
            this.tableColumns.unshift(item.code);
            const shortName = PerPhaseNames.find(p => p.code === item.code);
            this.codes[item.code] = shortName ? shortName.shortName : '';
        });

        this.tableColumns.unshift('name');
        this.codes['allphases'] = this._translate.instant('RESULT.ALL_PHASES');
        this.codes['unit'] = this._translate.instant('RESULT.UNIT');

        this.getCalculationCoreResults()
            .pipe(takeUntil(this._destroySubscription))
            .subscribe(() => {
                if (!this.isExistingBuildingCal) {
                    if (this.selectedDataSet == this.dataSetSetting.A1A2) {
                        this.nmdCalculationResponseDto_ForExtraIndicator = this.calculationResultsAfter;
                    } else if (this.selectedDataSet == this.dataSetSetting.A1) {
                        this.nmdCalculationResponseDto_ForExtraIndicator = this.calculationResults;
                    } else {
                        this.nmdCalculationResponseDto_ForExtraIndicator = this.calculationResults;
                    }
                }

            });

        this.combinationBuildingDetails = this.buildCombinationBuildingDetails();
        this.buildParameterGroupsCache();
    }

    ngOnDestroy(): void {
        this._destroySubscription.next(true);
        this._destroySubscription.complete();
        document.body.classList.remove('print-preview', 'popup-preview');
        document.documentElement.classList.remove('print-preview', 'popup-preview');
    }

    /**
   * To get the NmdCalculationResponseDto from API call 
   */
    getCalculationCoreResults(): Observable<NmdCalculationResponseWrapperDto> {
        // Guard: ensure a calculation id is available before calling the API.
        let calculationId: number = null;
        try {
            calculationId = this.appService.getCalculationId();
        } catch (err) {
            calculationId = null;
        }

        if (!calculationId) {
            return EMPTY as unknown as Observable<NmdCalculationResponseWrapperDto>;
        }

        return this._gprMaterialsService
            .getCalculationResultsForNewAndExistingBuildings(
                calculationId,
                this.isExistingBuildingCal
            )
            .pipe(
                tap((response: NmdCalculationResponseWrapperDto) => {
                    this.applyCalculationResultsFromSource(response);

                    // Mapping per phase
                    this.mappingPerPhasePer(this.calculationResults);
                    this.mappingPerPhasePer(this.calculationResultsAfter);
                }),
                catchError((err) => {
                    this.calculationResults = null;
                    return EMPTY; // swallow error so UI can still render partial data
                })
            );
    }

    /**
     * apply calculation results to the component properties based on the calculation type (existing or new building) and selected dataset.
     * @param response
     */
    private applyCalculationResultsFromSource(response: NmdCalculationResponseWrapperDto) {
        // For existing building
        if (this.isExistingBuildingCal) {
            if (this.selectedDataSet == this.dataSetSetting.A1) {
                this.calculationResults = response.existingBuildingCurrentResultsA1;
                this.calculationResultsAfter = response.existingBuildingAfterResultsA1;
            } else if (this.selectedDataSet == this.dataSetSetting.A2) {
                this.calculationResults = response.existingBuildingCurrentResultsA2;
                this.calculationResultsAfter = response.existingBuildingAfterResultsA2;
            }
        }
        // For new building
        else {
            if (this.selectedDataSet == this.dataSetSetting.A1A2) {
                this.calculationResults = response.newBuildingResultsA1;
                this.calculationResultsAfter = response.newBuildingResultsA2;
            } else if (this.selectedDataSet == this.dataSetSetting.A1) {
                this.calculationResults = response.newBuildingResultsA1;
            } else {
                this.calculationResults = response.newBuildingResultsA2;
            }
        }

        // Calling to create lists for categories
        this.prepareEnvironmentEffectsCategory();
        this.prepareIndicatorsCategory();
    }

    /**
     * Maps the names of `mpgPerPhase` and `mkiPerPhase` objects in the `NmdCalculationResponseDto` 
     * based on their corresponding `code` values from the `PerPhaseNames` array.
     * @param {NmdCalculationResponseDto} nmdCalculationResponseDto - The input object containing `mpgPerPhase` and `mkiPerPhase` arrays.
     */
    mappingPerPhasePer(nmdCalculationResponseDto: NmdCalculationResponseDto) {
        if (nmdCalculationResponseDto) {
            nmdCalculationResponseDto.mpgPerPhase.forEach((mpgPerPhase) => {
                const mpgPerPhaseName = PerPhaseNames.find(p => p.code === mpgPerPhase.code);
                mpgPerPhase['name'] = mpgPerPhaseName ? mpgPerPhaseName.name : '';
            });

            nmdCalculationResponseDto.mkiPerPhase.forEach((mkiPerPhase) => {
                const mkiPerPhaseName = PerPhaseNames.find(p => p.code === mkiPerPhase.code);
                mkiPerPhase['name'] = mkiPerPhaseName ? mkiPerPhaseName.name : '';
            });

            if (nmdCalculationResponseDto.gwp50PerPhase) {
                nmdCalculationResponseDto.gwp50PerPhase.forEach((gwp50PerPhase) => {
                    const gwp50PerPhaseName = PerPhaseNames.find(p => p.code === gwp50PerPhase.code);
                    gwp50PerPhase['name'] = gwp50PerPhaseName ? gwp50PerPhaseName.name : '';
                })
            }
        }
    }

    /**
     * Calculating lifespan for existing building inputs
     */
    setLifeSpansValuesForExistingBuilding() {
        let bouwjaarHuidigValue = 0;
        let verWatchSloojaarHuidigValue = 0;
        let jaarVanIngreepValue = 0;
        let verWatchSloojaarIngreepValue = 0;

        this.printData.mainCharacteristics
            .forEach(main => main.existingBuildingElements
                .forEach(existingBuilding => existingBuilding.parameters
                    .forEach(parameter => {
                        // huidig user input
                        if (existingBuilding.elementName === 'Huidig') {
                            if (parameter.name == 'Bouwjaar') {
                                bouwjaarHuidigValue = +parameter.value;
                            }
                            if (parameter.name == 'Verwacht Sloopjaar') {
                                verWatchSloojaarHuidigValue = +parameter.value;
                            }
                        }

                        // ingreep user input
                        if (existingBuilding.elementName === 'Ingreep') {
                            if (parameter.name == 'Jaar Van Ingreep') {
                                jaarVanIngreepValue = +parameter.value;
                            }
                            if (parameter.name == 'Verwacht Sloopjaar') {
                                verWatchSloojaarIngreepValue = +parameter.value;
                            }
                        }
                    })
                )
            );

        this.levensduurHuidig = verWatchSloojaarHuidigValue - bouwjaarHuidigValue;
        this.resterendLevensduurHuidig = verWatchSloojaarHuidigValue - jaarVanIngreepValue;
        this.levensduurIngreep = verWatchSloojaarIngreepValue - bouwjaarHuidigValue;
        this.resterendLevensduurIngreep = verWatchSloojaarIngreepValue - jaarVanIngreepValue;
    }

    ngAfterViewInit() {
        this.getCombinationBuildingFeatureFlag();

        if (this.appService.isPrintPreview()) {
            try {
                document.body.classList.add('print-preview', 'popup-preview');
                document.documentElement.classList.add('print-preview', 'popup-preview');
            } catch (e) { /* ignore */ }
        }

        if (!this.isPreview) {
            setTimeout(() => {
                window.print();
                this._router.navigate([{ outlets: { print: null } }]);
            }, 3000);
        }
    }

    /**
   * Creates the main element graph list.
   * @return {void} No return value.
   */
    createMainElementGraphList() {
        this.currentMainElements = (this.printData.mpgValuePerMainElements || []).map((mainElement: MpgValuePerMainElementDto, index) => {
            const mpgPercentage = this.calculatePercentage(mainElement.mpg, this.printData.totalMpg);

            return new MainElementDto(mainElement.mainElementId, mainElement.name, mainElement.mpg, this.colors[index], mpgPercentage);
        });

        if (this.isExistingBuildingCal || (!this.isExistingBuildingCal && this.selectedDataSet === this.dataSetSetting.A1A2)) {
            this.afterMainElements = (this.printData.mpgValuePerMainElements || []).map((mainElement: MpgValuePerMainElementDto, index) => {
                const mpgPercentage = this.calculatePercentage(mainElement.mpgAfter, this.printData.totalMpgAfter);

                return new MainElementDto(mainElement.mainElementId, mainElement.name, mainElement.mpgAfter, this.colors[index], mpgPercentage);
            });
        }
    }

    /**
   * Calculate percentage
   * @param partialValue 
   * @param totalValue 
   * @returns 
   */
    calculatePercentage(partialValue: number, totalValue: number): number {
        if (totalValue === 0) {
            return 0;
        }
        return +((100 * partialValue) / totalValue).toFixed();
    }

    /**
    * Set Calculation results based on dataSet setting and calculation type.
    */
    setCalculationResults() {
        this.applyCalculationResultsFromSource(this.printData.calculationResults);
        if (this.isExistingBuildingCal) {
            this.setLifeSpansValuesForExistingBuilding();
        }
    }

    /**
  * Get toggle event and creating indicators category list for table
  * @param isAfterResult 
  */
    prepareIndicatorsCategory(isAfterResult: boolean = false) {
        this.indicators = [];
        this.indicatorsAfter = [];

        try {
            if (isAfterResult) {
                this.calculationResultsAfter.valuePerPhasePerEnvironmentalEffectCategory.forEach((valuePerPhase, index) => {
                    this.prepareIndicators(valuePerPhase, index, true);
                });

            } else {
                this.calculationResults.valuePerPhasePerEnvironmentalEffectCategory.forEach((valuePerPhase, index) => {
                    this.prepareIndicators(valuePerPhase, index, false);
                });
            }

            this.calculateAllPhases(this.indicators);

        } catch (error) {
        }
    }

    /**
 * Prepare indicators for a given value per phase and index.
 * @param valuePerPhase: Single object from valuePerPhasePerEnvironmentalEffectCategory list
 * @param index: Index of valuePerPhasePerEnvironmentalEffectCategory list
 */
    prepareIndicators(valuePerPhase: ValuePerPhasePerEnvironmentalEffectDto, index: number, isAfter: boolean) {
        Indicators.forEach((indicator, eeIndex) => {
            let obj: ValuePerPhaseModel = {};
            if (index === 0) {
                isAfter ? this.indicatorsAfter.push(obj) : this.indicators.push(obj);
            } else {
                obj = isAfter ? this.indicatorsAfter[eeIndex] : this.indicators[eeIndex];
            }
            obj.name = indicator.name;
            obj.unit = indicator.unit;

            const matchedIndicator = valuePerPhase.indicators.find(item => item.id === indicator.id);
            if (matchedIndicator) {
                obj[valuePerPhase.code] = matchedIndicator.value;
            } else {
                obj[valuePerPhase.code] = 0;
            }
        });
    }

    /**
 * creating environment effects category list for table
 */
    prepareEnvironmentEffectsCategory() {
        this.environmentEffects = [];
        this.environmentEffectsAfter = [];

        try {

            if (this.calculationResultsAfter != undefined) {
                this.calculationResultsAfter?.valuePerPhasePerEnvironmentalEffectCategory.forEach((valuePerPhase, index) => {
                    this.prepareEnvironmentEffects(valuePerPhase, index, true);
                });
                this.calculationResultsAfter ? this.addMkiDetailsWithTotalMpgValue(true) : this.addMkiDetailsWithTotalMpgValue(false);
                this.calculateAllPhases(this.environmentEffectsAfter);
            }

            this.calculationResults?.valuePerPhasePerEnvironmentalEffectCategory.forEach((valuePerPhase, index) => {
                this.prepareEnvironmentEffects(valuePerPhase, index, false);
            });
            this.calculationResults ? this.addMkiDetailsWithTotalMpgValue(false) : this.addMkiDetailsWithTotalMpgValue(true);
            this.calculateAllPhases(this.environmentEffects);

        } catch (error) {
        }
    }

    /**
 * Calculating or sum of the all phases into a single value (allphases)
 * @param arrayList: It may take environmental effect or indicator array list
 */
    calculateAllPhases(arrayList: ValuePerPhaseModel[]) {
        if (arrayList.length > 0) {
            const codes = Object.keys(arrayList[0]).filter(key => !['name', 'unit', 'allphases'].includes(key))

            arrayList.forEach((element: ValuePerPhaseModel) => {
                element.allphases = codes.reduce((total, code) => total + element[code], 0);
            });
        }
    }

    /**
 * A function that prepares the environment effects based on the given value per phase and index.
 * @param valuePerPhase - The value per phase data.
 * @param index - The index of the current value per phase.
 * @param isAfter - The isAfter for CalculationResult.
 */
    prepareEnvironmentEffects(valuePerPhase: ValuePerPhasePerEnvironmentalEffectDto, index: number, isAfter: boolean) {
        let totalEnvCount = valuePerPhase.environmentEffects.length;
        let envEffects = this.getEnvironmentEffects(totalEnvCount);
        envEffects.forEach((environmentEffect, eeIndex) => {
            let obj: ValuePerPhaseModel = {};
            if (index === 0) {
                isAfter ? this.environmentEffectsAfter.push(obj) : this.environmentEffects.push(obj);
            }
            else {
                obj = isAfter ? this.environmentEffectsAfter[eeIndex] : this.environmentEffects[eeIndex];
            }
            obj.name = environmentEffect.name;
            obj.unit = environmentEffect.unit;

            const ee = valuePerPhase.environmentEffects.find(e => e.id === environmentEffect.id);

            if (ee) {
                obj[valuePerPhase.code] = ee.value;
            }
            else {
                // klimaatverandering - totaal(39) of 40, 41 and 42.
                if (this.selectedDataSet != this.dataSetSetting.A1 && environmentEffect.id == 39) {
                    const eeForFossiel = valuePerPhase.environmentEffects.find(e => e.id === 40); // klimaatverandering - fossiel
                    const eeForbiogeen = valuePerPhase.environmentEffects.find(e => e.id === 41); // klimaatverandering - biogeen
                    const eeForLandgebruik = valuePerPhase.environmentEffects.find(e => e.id === 42); // klimaatverandering - landgebruik en verandering landgebruik

                    obj[valuePerPhase.code] = eeForFossiel.value + eeForbiogeen.value + eeForLandgebruik.value;
                } else {
                    obj[valuePerPhase.code] = 0;
                }
            }
        });
    }

    /**
  * Getting EnvironmentEffects filter by selected assessmentStrategyId
  * @returns
  */
    getEnvironmentEffects(totalEnvCount: number = 0) {
        return (this.selectedDataSet == this.dataSetSetting.A1A2)
            ? EnvironmentEffects.filter(effect => effect.assessmentStrategyId === (totalEnvCount == EnvironmentEffects.filter(effect => effect.assessmentStrategyId === this.dataSetSetting.A1).length ? this.dataSetSetting.A1 : this.dataSetSetting.A2))
            : EnvironmentEffects.filter(effect => effect.assessmentStrategyId === this.selectedDataSet);
    }

    /**
  * Adding a data of MKI into environmental effect array list
  */
    addMkiDetailsWithTotalMpgValue(isAfterResult?: boolean) {
        const nmdCalculationResponseDto = isAfterResult ? this.calculationResultsAfter : this.calculationResults;
        const obj = {};

        obj['name'] = this._translate.instant('RESULT.MKI_HEADER');
        obj['unit'] = '';
        obj['allphases'] = nmdCalculationResponseDto.mki;
        nmdCalculationResponseDto.mkiPerPhase.forEach(item => {
            obj[item.code] = item.mki;
        });

        isAfterResult ? this.environmentEffectsAfter.push(obj) : this.environmentEffects.push(obj);
    }

    /**
  * Set header titles based on dataSet setting
  */
    setHeaderTitles() {
        if (this.selectedDataSet === DataSetSettingEnum.A1) {
            this.mpgResultTitle = this._translate.instant('PRINT_PAGE.MPG_RESULTSA1');
            this.mpgResultTitlePerMainElementTitle = this._translate.instant('PRINT_PAGE.MPG_RESULT_PER_MAIN_ELEMENTA1');
            this.elementResultTitle = this._translate.instant('PRINT_PAGE.ELEMENT_A1');
        }
        else if (this.selectedDataSet === DataSetSettingEnum.A2) {
            this.mpgResultTitle = this._translate.instant('PRINT_PAGE.MPG_RESULTSA2');
            this.mpgResultTitlePerMainElementTitle = this._translate.instant('PRINT_PAGE.MPG_RESULT_PER_MAIN_ELEMENTA2');
            this.elementResultTitle = this._translate.instant('PRINT_PAGE.ELEMENT_A2');
        }
        else {
            this.mpgResultTitle = this._translate.instant('PRINT_PAGE.MPG_RESULTSA1ANDA2');
            this.mpgResultTitlePerMainElementTitle = this._translate.instant('PRINT_PAGE.MPG_RESULT_PER_MAIN_ELEMENTA1ANDA2');
            this.elementResultTitle = this._translate.instant('PRINT_PAGE.ELEMENT_A1ANDA2');
        }
        this.envirnmentalCategoryTitle = this._translate.instant('PRINT_PAGE.ENVIRONMENTALCATEGORY');
    }



    /**
     * Filters parameters to exclude combination building-specific parameters when displaying
     * building characteristics for combination buildings.
     * @param parameters Array of parameters to filter
     * @returns Filtered array of parameters
     */
    getFilteredParameters(parameters: GprPrintParameterDto[]): GprPrintParameterDto[] {
        if (!parameters) {
            return [];
        }


        const normalizedCombinationParams = Object.values(CombinationSpecificParamNamesEnum).map(name =>
            this.normalizeKey(name)
        );

        // Filter out combination-specific parameters
        return parameters.filter(param => {
            const normalizedParamName = this.normalizeKey(param.name);
            
            // Check if the parameter name matches any of the combination-specific parameters
            return !normalizedCombinationParams.some(combParam => 
                normalizedParamName === combParam || 
                normalizedParamName.includes(combParam) || 
                combParam.includes(normalizedParamName)
            );
        });
    }

    /**
     * Normalizes a value by converting to lowercase and trimming whitespace.
     * @param value The value to normalize
     * @returns Normalized string
     */
    private normalize(value: unknown): string {
        return String(value ?? '').trim().toLowerCase();
    }

    /**
     * Normalizes a key by removing all non-alphanumeric characters.
     * @param value The value to normalize
     * @returns Normalized key string
     */
    private normalizeKey(value: unknown): string {
        return this.normalizeKeyPipe.transform(value);
    }

    /**
     * Gets the prepared by username from printData.
     * @returns The username who prepared the print
     */
    get preparedBy(): string {
        return (this.printData && this.printData.createdByUserName);
    }

    /**
     * Gets the organisation name from printData.
     * @returns The organisation name
     */
    get organisationName(): string {
        return (this.printData && this.printData.organisationName);
    }

    /**
     * Returns true when the value is a JSON array or object string (should be hidden from the print view).
     */
    isJsonValue(value: string | undefined): boolean {
        if (!value) return false;
        const trimmed = value.trim();
        return trimmed.startsWith('[') || trimmed.startsWith('{');
    }

   
    /**
     * Gets the cached parameter groups for a main characteristic.
     * @param characteristic The main characteristic to get parameter groups for
     * @returns Array of parameter groups, each containing up to 4 parameters
     */
    getParameterGroups(characteristic: any): any[][] {
        return this.parameterGroupsCache.get(characteristic) || [];
    }

    /**
     * Checks if building characteristics has 3 or more columns.
     * Returns true if any main characteristic has 3 or more parameter groups.
     * @returns True if 3 or more columns are needed, false otherwise
     */
    hasThreeOrMoreColumns(): boolean {
        if (!this.printData?.mainCharacteristics) {
            return false;
        }

        return this.printData.mainCharacteristics.some(characteristic => {
            const paramGroups = this.parameterGroupsCache.get(characteristic);
            return paramGroups && paramGroups.length >= 3;
        });
    }




    private buildCombinationBuildingDetails(): CombinationBuildingPrintDto | null {
        const characteristics = this.printData?.mainCharacteristics ?? [];

        const combinationBuilding = characteristics.find(x =>
            this.normalize(this.getParameterValue(x, [PrintPageComponent.PARAM_BUILDING_USE_FUNCTION])) === 'combinatiegebouw'
        );

        if (!combinationBuilding) {
            return null;
        }

        const parsedFunctions = this.getCombinationFunctions(combinationBuilding);
        const functions = parsedFunctions.length
            ? parsedFunctions
            : characteristics
                .filter(x => x !== combinationBuilding)
                .filter(x => !!this.getParameterValue(x, [PrintPageComponent.PARAM_BUILDING_USE_FUNCTION]))
                .map(x => this.mapFunction(x))
                .filter(x => x.name && this.normalize(x.name) !== 'combinatiegebouw');

        const sharedSpaces = this.getSharedSpaces(combinationBuilding, functions);

        return {
            functions,
            sharedSpaces,
            facadeSurface: {
                surface: this.readNumber(combinationBuilding, [
                    PrintPageComponent.PARAM_FACADE_SURFACE_NEW_OR_CURRENT
                ], 0),
                compactness: this.readNumber(combinationBuilding, [
                    PrintPageComponent.PARAM_COMPACTNESS_NEW_OR_CURRENT
                ], 0),
                mpgAmbition: this.readNumber(combinationBuilding, [
                    'MPG ambitie',
                    PrintPageComponent.PARAM_MPG_AMBITION_NEW_OR_CURRENT
                ], 0),
                // Note: Search for mpgLimitEasedA2 first as it's more specific (longer string)
                // to avoid fuzzy matching issues where "Mpg Limit" matches "Mpg Limit Eased"
                mpgLimitEasedA2: this.readNumber(combinationBuilding, [
                    PrintPageComponent.PARAM_MPG_LIMIT_EASED_A2_NEW_OR_CURRENT
                ], 0),
                mpgLimitA2: this.readNumber(combinationBuilding, [
                    PrintPageComponent.PARAM_MPG_LIMIT_A2_NEW_OR_CURRENT
                ], 0),
                correctionFactor: this.readNumber(combinationBuilding, [
                    PrintPageComponent.PARAM_CORRECTION_FACTOR_NEW_OR_CURRENT
                ], 0)
            }
        };
    }

    private getCombinationFunctions(source: any): any[] {
        const rows = this.getJsonArray(source, [
            PrintPageComponent.PARAM_FUNCTION_NEW_OR_CURRENT
        ]);

        return rows.map((row: any) => {
            const referenceNumber = this.readNumber(row, ['referenceNumber'], 0);
            const buildingUseFunctionId = this.readNumber(row, ['buildingUseFunctionId'], 0);
            const units = this.readNumber(row, [
                PrintPageComponent.PARAM_NUMBER_OF_UNITS
            ], 1);
            const go = this.readNumber(row, [
                PrintPageComponent.PARAM_GBO
            ], 0);
            const explicitName = this.readText(row, [
                PrintPageComponent.PARAM_BUILDING_USE_FUNCTION.toLowerCase()
            ]);

            // Use mpgLimitEasedA2 if it exists and is not empty, otherwise use mpgLimitA2
            const mpgLimitEasedA2 = this.readNumber(row, ['mpgLimitEasedA2'], 0);
            const mpgLimitA2 = this.readNumber(row, ['mpgLimitA2'], 0);
            const mpgRequirement = (mpgLimitEasedA2 !== 0) ? mpgLimitEasedA2 : mpgLimitA2;
            const goGemRunTime = this.readNumber(row, ['goGemRuntimeFloorArea', 'goGemRunTime'], 0);
            const goTotal = this.readNumber(row, ['totalUsableFloorArea'], units * go);

            return {
                referenceNumber,
                buildingUseFunctionId,
                name: explicitName || BuildingUseFunctionNamesById[buildingUseFunctionId] || `Functie ${buildingUseFunctionId || referenceNumber}`,
                units,
                go,
                goGemRunTime,
                goTotal,
                mpgRequirement: mpgRequirement
            };
        });
    }

    private mapFunction(source: any) {
        const units = this.readNumber(source, [
            PrintPageComponent.PARAM_NUMBER_OF_UNITS
        ], 1);
        const go = this.readNumber(source, [
            PrintPageComponent.PARAM_GBO
        ], 0);

        // Use mpgLimitEasedA2 if it exists and is not empty, otherwise use mpgLimitA2
        const mpgLimitEasedA2 = this.readNumber(source, ['mpgLimitEasedA2'], 0);
        const mpgLimitA2 = this.readNumber(source, ['mpgLimitA2'], 0);
        const mpgRequirement = (mpgLimitEasedA2 !== 0) ? mpgLimitEasedA2 : mpgLimitA2;
        const goGemRunTime = this.readNumber(source, ['goGemRuntimeFloorArea', 'goGemRunTime'], 0);

        return {
            name: this.getParameterValue(source, [PrintPageComponent.PARAM_BUILDING_USE_FUNCTION]) ?? '',
            units,
            go,
            goGemRunTime,
            goTotal: this.readNumber(source, ['totalUsableFloorArea'], units * go),
            mpgRequirement: mpgRequirement
        };
    }

    private getSharedSpaces(source: any, functions: any[] = []) {
        const rows = this.getJsonArray(source, [
            PrintPageComponent.PARAM_COMMON_AREA_NEW_OR_CURRENT
        ]);

        const functionLookup = new Map<number, any>(functions
            .filter(x => Number.isFinite(x.referenceNumber))
            .map(x => [x.referenceNumber, x]));

        return rows.map(row => {
            const referenceNumber = this.readNumber(row, ['functionReferenceNumber'], 0);
            const buildingUseFunctionId = this.readNumber(row, ['buildingUseFunctionId'], 0);
            const isEvenlyDistributed = buildingUseFunctionId === 15;
            const normalizedReferenceNumber = referenceNumber > 0 ? referenceNumber : undefined;

            const derivedAllocation = functionLookup.get(normalizedReferenceNumber)?.name
                || BuildingUseFunctionNamesById[buildingUseFunctionId]
                || '';

            const allocationLabel = normalizedReferenceNumber != null
                ? `${normalizedReferenceNumber} ${derivedAllocation}`.trim()
                : derivedAllocation;

            return {
                name: this.readText(row, ['name']),
                gbo: this.readNumber(row, ['usableFloorArea'], 0),
                allocation: allocationLabel,
                functionReferenceNumber: normalizedReferenceNumber,
                isEvenlyDistributed
            };
        });
    }

    private getJsonArray(source: any, names: string[]): any[] {
        const raw = this.readRaw(source, names);

        if (!raw || typeof raw !== 'string' || !this.isJsonValue(raw)) {
            return [];
        }

        try {
            const parsed = JSON.parse(raw);
            return Array.isArray(parsed) ? parsed : [parsed];
        } catch {
            return [];
        }
    }

    private readNumber(source: any, names: string[], fallback: number): number {
        const raw = this.readRaw(source, names);

        if (raw === undefined || raw === null || raw === '') {
            return fallback;
        }

        const value = String(raw)
            .replace('m²', '')
            .replace('jaar', '')
            .trim();

        const normalized = value.includes(',')
            ? value.replace(/\./g, '').replace(',', '.')
            : value.match(/^\d{1,3}(\.\d{3})+$/)
                ? value.replace(/\./g, '')
                : value;

        const result = Number(normalized);

        return Number.isFinite(result) ? result : fallback;
    }

    private readText(source: any, names: string[]): string {
        const value = this.readRaw(source, names);
        return value === undefined || value === null ? '' : String(value);
    }

    private getParameterValue(source: any, names: string[]): string | undefined {
        const value = this.readRaw(source, names);
        return value === undefined || value === null ? undefined : String(value);
    }

    private readRaw(source: any, names: string[]): any {
        const parameters = source?.parameters ?? [];
        const normalizedNames = names.map(x => this.normalizeKey(x));

        for (const name of normalizedNames) {
            const parameter = parameters.find((x: any) =>
                this.normalizeKey(x?.name) === name
            );

            if (parameter) {
                return parameter.value;
            }
        }

        for (const name of normalizedNames) {
            const parameter = parameters.find((x: any) => {
                const key = this.normalizeKey(x?.name);
                return key.includes(name) || name.includes(key);
            });

            if (parameter) {
                return parameter.value;
            }
        }

        for (const name of normalizedNames) {
            const key = Object.keys(source ?? {}).find(x =>
                this.normalizeKey(x) === name
            );

            if (key) {
                return source[key];
            }
        }

        for (const name of normalizedNames) {
            const key = Object.keys(source ?? {}).find(x => {
                const normalizedKey = this.normalizeKey(x);
                return normalizedKey.includes(name) || name.includes(normalizedKey);
            });

            if (key) {
                return source[key];
            }
        }

        return undefined;
    }


    /**
     * Builds a cache of parameter groups for all main characteristics.
     * This is called once in ngOnChanges to avoid repeated calculations during change detection.
     */
    private buildParameterGroupsCache(): void {
        this.parameterGroupsCache.clear();

        if (!this.printData?.mainCharacteristics) {
            return;
        }

        this.printData.mainCharacteristics.forEach(characteristic => {
            if (characteristic.parameters) {
                const groups = this.computeParameterGroups(characteristic.parameters);
                this.parameterGroupsCache.set(characteristic, groups);
            }
        });
    }

    /**
     * Computes parameter groups from raw parameters.
     * Splits parameters into groups of 4 (excluding JSON values) for display in columns.
     * Each group will be rendered as a separate column with a divider (except the first).
     * For combination buildings, filters out combination-specific parameters that are shown on the dedicated page.
     * @param parameters Array of parameters to group
     * @returns Array of parameter groups, each containing up to 4 parameters
     */
    private computeParameterGroups(parameters: any[]): any[][] {
        if (!parameters || !parameters.length) {
            return [];
        }

        // Filter out JSON values first
        let validParameters = parameters.filter(param => !this.isJsonValue(param.value));

        
        const combinationOnlyExcludedParams = [
            PrintPageComponent.PARAM_FACADE_SURFACE_NEW_OR_CURRENT,
            PrintPageComponent.PARAM_MPG_AMBITION_NEW_OR_CURRENT,
            PrintPageComponent.PARAM_COMPACTNESS_NEW_OR_CURRENT,
            PrintPageComponent.PARAM_FUNCTION_NEW_OR_CURRENT,
            PrintPageComponent.PARAM_COMMON_AREA_NEW_OR_CURRENT,
            PrintPageComponent.PARAM_MPG_LIMIT_A2_NEW_OR_CURRENT,
            PrintPageComponent.PARAM_MPG_LIMIT_EASED_A2_NEW_OR_CURRENT,
            PrintPageComponent.PARAM_CORRECTION_FACTOR_NEW_OR_CURRENT
        ];

        const excludedParamNames = new Set(
            [
                ...(this.isCombinationBuildingSelected ? combinationOnlyExcludedParams : [])
            ].map(name => this.normalizeKey(name))
        );

        validParameters = validParameters.filter(param =>
            !excludedParamNames.has(this.normalizeKey(param.name))
        );

        const mpgLimitKey = this.normalizeKey(PrintPageComponent.PARAM_MPG_LIMIT_A2_NEW_OR_CURRENT);
        const mpgLimitEasedKey = this.normalizeKey(PrintPageComponent.PARAM_MPG_LIMIT_EASED_A2_NEW_OR_CURRENT);
        const mpgLimitParam = validParameters.find(param => this.normalizeKey(param.name) === mpgLimitKey);
        const mpgLimitEasedParam = validParameters.find(param => this.normalizeKey(param.name) === mpgLimitEasedKey);

        if (mpgLimitParam && mpgLimitEasedParam) {
            const hasMpgLimitEasedValue = this.normalize(mpgLimitEasedParam.value) !== '';

            validParameters = validParameters.filter(param => {
                const paramKey = this.normalizeKey(param.name);

                if (hasMpgLimitEasedValue && paramKey === mpgLimitKey) {
                    return false;
                }

                if (!hasMpgLimitEasedValue && paramKey === mpgLimitEasedKey) {
                    return false;
                }

                return true;
            });
        }

        validParameters = validParameters.map(param => this.prepareParameterForPrint(param));

        // Split into groups of 4
        const groups: any[][] = [];
        const groupSize = 4;

        for (let i = 0; i < validParameters.length; i += groupSize) {
            groups.push(validParameters.slice(i, i + groupSize));
        }

        return groups;
    }

    private prepareParameterForPrint(parameter: any): any {
        if (!parameter) {
            return parameter;
        }

        if (this.isMpgLimitParameter(parameter.name)) {
            return { ...parameter, name: PrintPageComponent.PARAM_MPG_LIMIT_A2_PRINT_NAME };
        }

        if (this.isCorrectionFactorParameter(parameter.name)) {
            const formattedValue = this.formatCorrectionFactor(parameter.value);
            return { ...parameter, value: formattedValue };
        }

        return parameter;
    }

    private isMpgLimitParameter(name: unknown): boolean {
        const normalized = this.normalizeKey(name);
        return normalized === this.normalizeKey(PrintPageComponent.PARAM_MPG_LIMIT_A2_NEW_OR_CURRENT)
            || normalized === this.normalizeKey(PrintPageComponent.PARAM_MPG_LIMIT_EASED_A2_NEW_OR_CURRENT);
    }

    private isCorrectionFactorParameter(name: unknown): boolean {
        const normalized = this.normalizeKey(name);
        return normalized === this.normalizeKey(PrintPageComponent.PARAM_CORRECTION_FACTOR_NEW_OR_CURRENT)
            || normalized === 'correctionfactor';
    }

    private formatCorrectionFactor(value: unknown): unknown {
        const text = String(value ?? '').trim();

        if (!text) {
            return value;
        }

        const normalized = this.decimalSeparatorPipe.transform(text, 'toDot');
        const parsed = Number(normalized);

        if (!Number.isFinite(parsed)) {
            return value;
        }

        return this.decimalSeparatorPipe.transform(parsed.toFixed(2), 'toComma');
    }



    /**
* get CombinationBuildingFeatureFlag feature flag
*/
    getCombinationBuildingFeatureFlag() {
        this._featureService.isShowCombinationBuildingFeature()
            .pipe(takeUntil(this._onDestroy))
            .subscribe(resp => this.isShowCombinationBuildingFeature = resp);
    }


}
